import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router-dom';

import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import { glossary } from '@sorare/core/src/lib/glossary';

const tabs = [
  {
    label: glossary.boxScore,
  },
  {
    label: glossary.players,
  },
];

const ScoutingCenterGameIdLayout = () => {
  return (
    <ContentWithStickyHeader
      header={
        <TabBar variant="flat" fullWidth ignoreQueryParams>
          {tabs.map(({ label }) => (
            <Tab key={label.id} to="#">
              <FormattedMessage {...label} />
            </Tab>
          ))}
        </TabBar>
      }
    >
      <Outlet />
    </ContentWithStickyHeader>
  );
};

export default ScoutingCenterGameIdLayout;
